import { render, staticRenderFns } from "./TeamBuilderSteps.vue?vue&type=template&id=55c63c05&lang=pug&"
import script from "./TeamBuilderSteps.vue?vue&type=script&lang=js&"
export * from "./TeamBuilderSteps.vue?vue&type=script&lang=js&"
import style0 from "./TeamBuilderSteps.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports